<mat-icon
  [ngStyle]="{ color: color, fill: color }"
  class="battery-icon"
  [svgIcon]="getIcon()"
></mat-icon>
